"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = __importStar(require("react"));
function UndrawData(p) {
  var primaryColor = p.primaryColor,
    height = p.height,
    style = p.style,
    props = __rest(p, ["primaryColor", "height", "style"]);
  var styleProps = __assign({
    width: '100%',
    height: height
  }, style);
  return React.createElement("svg", __assign({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 995 697.681",
    style: styleProps
  }, props), React.createElement("path", {
    d: "M812.689 437.548H171.85a16.519 16.519 0 01-16.5-16.5V25.894a12.102 12.102 0 0112.088-12.088h649.453a12.311 12.311 0 0112.298 12.297v394.945a16.519 16.519 0 01-16.5 16.5z",
    fill: "#f2f2f2"
  }), React.createElement("path", {
    d: "M789.311 414.181H192.067c-8.755 0-15.878-6.67-15.878-14.868V55.208c0-6.08 5.278-11.027 11.766-11.027h605.273c6.596 0 11.961 5.028 11.961 11.209v343.923c0 8.198-7.123 14.868-15.878 14.868z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M828.959 24.95h-673.84v-8.4A16.574 16.574 0 01171.679 0h640.72a16.574 16.574 0 0116.56 16.55z",
    fill: "#ccc"
  }), React.createElement("circle", {
    cx: 185.214,
    cy: 12.5,
    r: 4.283,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 201.473,
    cy: 12.5,
    r: 4.283,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 217.731,
    cy: 12.5,
    r: 4.283,
    fill: "#fff"
  }), React.createElement("path", {
    d: "M723.573 356.47H260.734a17.52 17.52 0 01-17.5-17.5V115.814a13.103 13.103 0 0113.088-13.088h471.454a13.312 13.312 0 0113.297 13.297V338.97a17.52 17.52 0 01-17.5 17.5zm-467.25-251.743a11.1 11.1 0 00-11.089 11.088V338.97a15.517 15.517 0 0015.5 15.5h462.839a15.518 15.518 0 0015.5-15.5V116.024a11.31 11.31 0 00-11.297-11.297z",
    fill: "#ccc"
  }), React.createElement("path", {
    d: "M276.734 338.97h430.839a16 16 0 0016-16V136.42a16 16 0 00-16-16H276.734a16 16 0 00-16 16V322.97a16 16 0 0016 16z",
    fill: "#f2f2f2"
  }), React.createElement("circle", {
    cx: 325.654,
    cy: 165.695,
    r: 9,
    fill: "#ccc"
  }), React.createElement("circle", {
    cx: 325.654,
    cy: 199.695,
    r: 9,
    fill: "#ccc"
  }), React.createElement("circle", {
    cx: 325.654,
    cy: 233.695,
    r: 9,
    fill: "#ccc"
  }), React.createElement("circle", {
    cx: 325.654,
    cy: 267.695,
    r: 9,
    fill: "#ccc"
  }), React.createElement("path", {
    d: "M666.654 166.695h-296a1 1 0 010-2h296a1 1 0 010 2zM666.654 200.695h-296a1 1 0 010-2h296a1 1 0 010 2zM666.654 234.695h-296a1 1 0 010-2h296a1 1 0 010 2zM666.654 268.695h-296a1 1 0 010-2h296a1 1 0 010 2z",
    fill: "#ccc"
  }), React.createElement("path", {
    d: "M426.654 302.695h-29a5.006 5.006 0 01-5-5v-27a5.006 5.006 0 015-5h29a5.006 5.006 0 015 5v27a5.006 5.006 0 01-5 5zM491.654 302.695h-29a5.006 5.006 0 01-5-5v-61a5.006 5.006 0 015-5h29a5.006 5.006 0 015 5v61a5.006 5.006 0 01-5 5zM557.654 302.695h-29a5.006 5.006 0 01-5-5v-95a5.006 5.006 0 015-5h29a5.006 5.006 0 015 5v95a5.006 5.006 0 01-5 5zM625.654 302.695h-29a5.006 5.006 0 01-5-5v-128a5.006 5.006 0 015-5h29a5.006 5.006 0 015 5v128a5.006 5.006 0 01-5 5z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M666.654 302.695h-296a1 1 0 010-2h296a1 1 0 010 2z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M796.701 489.243a10.056 10.056 0 0115.32-1.744l31.756-16.388-1.975 18.464-29.852 12.732a10.11 10.11 0 01-15.249-13.064z",
    fill: "#ffb8b8"
  }), React.createElement("path", {
    d: "M824.024 496.13a4.506 4.506 0 01-1.523-2.212l-2.526-8.16a4.515 4.515 0 011.587-4.921l25.737-19.44 27.876-51.713a14.497 14.497 0 1122.9 17.782l-15.859 33.47a46.374 46.374 0 01-23.463 22.697l-30.163 13.083a4.505 4.505 0 01-3.669-.04 4.455 4.455 0 01-.897-.547z",
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 898.775,
    cy: 363.541,
    r: 24.561,
    fill: "#ffb8b8"
  }), React.createElement("path", {
    fill: "#ffb8b8",
    d: "M888.812 685.737l-12.259-.001-5.831-47.288 18.095.001-.005 47.288z"
  }), React.createElement("path", {
    d: "M867.795 682.233h23.644v14.887h-38.53a14.887 14.887 0 0114.886-14.887z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    fill: "#ffb8b8",
    d: "M928.812 685.739l-12.259-.001-5.831-47.289 18.095.002-.005 47.288z"
  }), React.createElement("path", {
    d: "M907.795 682.235h23.644v14.886h-38.53a14.887 14.887 0 0114.886-14.886zM929.708 673.74l-14.367-.001a4.508 4.508 0 01-4.345-3.33l-20.68-76.7a.5.5 0 00-.981.16l4.177 72.742a4.5 4.5 0 01-4.866 4.742l-16.148-1.347a4.512 4.512 0 01-4.096-3.964l-14.71-152.744 5.69 3.415 53.33-9.054 21.457 160.986a4.5 4.5 0 01-4.46 5.094z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M871.527 529.42a32.94 32.94 0 01-16.692-4.699 4.48 4.48 0 01-2.136-4.589c1.875-11.486 11.684-70.407 20.608-102.529 3.635-13.083 11.671-20.13 23.887-20.943 17.868-1.172 33.75 12.807 35.403 31.2 2.918 32.448-8.933 78.55-14.163 96.865a4.496 4.496 0 01-7.088 2.307l-10.661-8.294a3.533 3.533 0 00-4.516.188c-8.987 8.016-17.523 10.494-24.642 10.493z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    opacity: 0.2,
    d: "M906.787 443.738l8.999 38.001-13.002 31.999 9.002-30.999-4.999-39.001z"
  }), React.createElement("path", {
    d: "M912.79 383.739a16.538 16.538 0 006.388-1.156c.894-.344 1.822-.627 2.715-.972 7.882-3.045 13.074-11.439 13.26-19.886s-4.188-16.647-10.683-22.05-14.91-8.179-23.335-8.82c-9.075-.692-19.294 1.61-24.366 9.167-1.35 2.011-2.294 4.452-1.494 6.881a4.404 4.404 0 001.24 1.906c2.265 2.015 4.523.5 6.832.367 3.173-.184 6.023 2.384 7.047 5.393s.574 6.322-.254 9.391a23.459 23.459 0 00-1.182 5.71 5.74 5.74 0 002.378 5.055c1.983 1.199 4.587.505 6.57-.691s3.7-2.86 5.843-3.741 5.022-.685 6.27 1.267a6.935 6.935 0 01.792 2.289c1.118 5.095.861 4.795 1.98 9.89z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M874.721 651.432L720.925 597.87a10.556 10.556 0 01-6.49-13.426l39.966-114.758a7.734 7.734 0 019.836-4.755l158.995 55.371a7.867 7.867 0 014.837 10.006l-39.922 114.633a10.556 10.556 0 01-13.426 6.49z",
    fill: "#e6e6e6"
  }), React.createElement("path", {
    d: "M734.05 591.276l134.483 46.835a10.225 10.225 0 0013.019-6.293l32.272-92.667a10.225 10.225 0 00-6.293-13.019l-134.484-46.835a10.225 10.225 0 00-13.019 6.293l-32.272 92.667a10.225 10.225 0 006.293 13.019z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M767.82 526.17l-6.66-2.32a1.444 1.444 0 01-.888-1.837l2.32-6.66a1.444 1.444 0 011.836-.888l6.66 2.32a1.444 1.444 0 01.888 1.836l-2.32 6.66a1.444 1.444 0 01-1.836.888z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M761.81 543.426l-6.66-2.32a1.444 1.444 0 01-.888-1.837l2.32-6.66a1.444 1.444 0 011.836-.888l6.66 2.32a1.444 1.444 0 01.889 1.836l-2.32 6.66a1.444 1.444 0 01-1.837.889z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M755.8 560.682l-6.66-2.32a1.444 1.444 0 01-.887-1.837l2.32-6.66a1.444 1.444 0 011.836-.888l6.66 2.32a1.444 1.444 0 01.888 1.837l-2.32 6.66a1.444 1.444 0 01-1.836.888zM812.574 538.021l-32.09-11.175a1.443 1.443 0 11.949-2.725l32.09 11.176a1.443 1.443 0 11-.949 2.724zM806.565 555.278l-32.09-11.176a1.443 1.443 0 01.948-2.725l32.09 11.176a1.443 1.443 0 11-.948 2.725zM800.555 572.534l-32.09-11.176a1.443 1.443 0 01.948-2.725l32.09 11.176a1.443 1.443 0 01-.948 2.725z",
    fill: "#ccc"
  }), React.createElement("path", {
    d: "M885.954 581.883c.233-.56.454-1.13.656-1.712A30.239 30.239 0 00868 541.67l-10.548 30.287z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M854.384 573.8l10.547-30.288a30.239 30.239 0 1017.955 40.214z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M892.145 530.353a10.056 10.056 0 0110.98-10.827l14.873-32.492 9.84 15.748-15.632 28.44a10.11 10.11 0 01-20.061-.87z",
    fill: "#ffb8b8"
  }), React.createElement("path", {
    d: "M917.894 518.91a4.506 4.506 0 01-2.563-.8l-7.023-4.862a4.515 4.515 0 01-1.788-4.851l8.255-31.18-9.98-57.894a14.497 14.497 0 1128.994-.14l8.176 36.123a46.373 46.373 0 01-4.456 32.34l-15.66 28.908a4.505 4.505 0 01-2.911 2.233 4.455 4.455 0 01-1.044.123z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M994 697.681H804a1 1 0 010-2h190a1 1 0 010 2z",
    fill: "#ccc"
  }), React.createElement("path", {
    fill: "#a0616a",
    d: "M490.541 685.239l12.26-.001 5.832-47.287h-18.094l.002 47.288z"
  }), React.createElement("path", {
    d: "M487.414 681.236h24.144a15.386 15.386 0 0115.387 15.386v.5l-39.53.001z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    fill: "#a0616a",
    d: "M441.541 685.239l12.26-.001 5.832-47.287h-18.094l.002 47.288z"
  }), React.createElement("path", {
    d: "M438.414 681.236h24.144a15.386 15.386 0 0115.387 15.386v.5l-39.53.001z",
    fill: "#2f2e41"
  }), React.createElement("circle", {
    cx: 492.988,
    cy: 333.297,
    r: 24.561,
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M509.505 675.033h-22.751a4.5 4.5 0 01-4.5-4.555l1.322-108.031a1.5 1.5 0 00-2.989-.2l-13.24 108.83a4.504 4.504 0 01-4.467 3.956h-22.97a4.5 4.5 0 01-4.486-4.85l15.168-194.076.412-.045 72.629-7.844L514 670.747a4.495 4.495 0 01-4.495 4.286z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M451.476 488.021a4.496 4.496 0 01-4.484-4.358c-.397-12.272-1.076-54.733 6.822-85.905a40.924 40.924 0 0137.792-30.84 41.18 41.18 0 0140.559 26.024c13.275 33.703 25.818 75.246 10.18 81.762-20.494 8.539-74.523 12.345-90.593 13.308q-.14.01-.276.01z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M545.347 308.473a10.525 10.525 0 001.246 1.093l-2.578 49.526-10.725 5.49 6.171 17.269 19.93-7.875a8 8 0 005.026-8.18l-5.222-56.18a10.497 10.497 0 10-13.848-1.143z",
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M544.218 360.936l7.544 21.439a4.5 4.5 0 01-3.389 5.911l-22.245 4.308a12.497 12.497 0 01-8.228-23.602l19.974-10.543a4.5 4.5 0 016.344 2.487z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M438.96 308.473a10.527 10.527 0 01-1.246 1.093l2.579 49.526 10.724 5.49-6.171 17.269-19.93-7.875a8 8 0 01-5.026-8.18l5.222-56.18a10.497 10.497 0 1113.848-1.143z",
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M442.692 358.24a4.495 4.495 0 013.741.21l19.974 10.542a12.497 12.497 0 01-8.228 23.602l-22.245-4.308a4.5 4.5 0 01-3.39-5.911l7.545-21.44a4.495 4.495 0 012.603-2.695z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M502.527 337.484a16.143 16.143 0 019.041-15.168c7.466-3.854 12.156-12.075 10.1-19.582-2.63-9.61-15.708-15.84-26.304-12.535a48.566 48.566 0 00-8.261 3.84l-6.923 3.71a71.73 71.73 0 00-8.534 5.038 28.315 28.315 0 00-11.27 26.53c1.363 9.769 7.76 18.728 16.517 24.861a27.937 27.937 0 0011.319 5.031c4.197.692 8.87-.094 11.94-2.704 4.796-4.08 4.3-10.911 2.749-16.617a12.09 12.09 0 01-.374-2.404z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M586 697.681H396a1 1 0 010-2h190a1 1 0 010 2z",
    fill: "#ccc"
  }), React.createElement("path", {
    d: "M275.91 515.254L119.133 579.57a10.984 10.984 0 01-14.316-5.987L56.825 456.601a8.047 8.047 0 014.386-10.487l162.077-66.492a8.186 8.186 0 0110.669 4.462l47.94 116.854a10.984 10.984 0 01-5.987 14.316z",
    fill: "#e6e6e6"
  }), React.createElement("path", {
    d: "M124.811 565.382l137.091-56.241a10.64 10.64 0 005.805-13.882l-38.753-94.462a10.64 10.64 0 00-13.881-5.806L77.982 451.232a10.64 10.64 0 00-5.805 13.882l38.753 94.463a10.64 10.64 0 0013.881 5.805z",
    fill: "#fff"
  }), React.createElement("path", {
    fill: "#e6e6e6",
    d: "M226.18 427.385l2.016-.827.138.336-2.016.827zM222.247 429.391l-4.072 1.67-.137-.335 4.071-1.67zm-8.143 3.341l-4.072 1.67-.138-.335 4.072-1.67zm-8.144 3.34l-4.072 1.671-.137-.336 4.071-1.67zm-8.143 3.342l-4.072 1.67-.138-.336 4.072-1.67zm-8.144 3.34l-4.072 1.671-.137-.336 4.071-1.67zm-8.143 3.341l-4.072 1.67-.138-.335 4.072-1.67zm-8.144 3.341l-4.072 1.67-.137-.335 4.071-1.67zm-8.143 3.341l-4.072 1.67-.138-.335 4.072-1.67zm-8.144 3.341l-4.072 1.67-.137-.336 4.071-1.67zm-8.143 3.34l-4.072 1.671-.138-.336 4.072-1.67zm-8.144 3.342l-4.072 1.67-.138-.336 4.072-1.67zm-8.144 3.34l-4.071 1.671-.138-.336 4.072-1.67zm-8.143 3.341l-4.072 1.67-.138-.335 4.072-1.67zm-8.144 3.341l-4.071 1.67-.138-.335 4.072-1.67zm-8.143 3.341l-4.072 1.67-.138-.335 4.072-1.67zm-8.144 3.341l-4.071 1.67-.138-.335 4.072-1.67zM89.798 483.336l2.015-.827.138.335-2.016.827zM172.821 485.773l2.016-.827.138.336-2.016.827zM168.948 487.756l-4.012 1.645-.137-.336 4.01-1.645zm-8.023 3.29l-4.011 1.646-.138-.336 4.011-1.645zm-8.022 3.292l-4.012 1.646-.138-.336 4.012-1.646zm-8.023 3.291l-4.011 1.646-.138-.336 4.011-1.646zm-8.023 3.292l-4.01 1.645-.139-.336 4.012-1.645zm-8.022 3.29l-4.011 1.646-.138-.336 4.011-1.645zm-8.023 3.292l-4.011 1.646-.138-.336 4.012-1.646zm-8.022 3.291l-4.011 1.646-.138-.336 4.011-1.646zM102.614 514.577l2.016-.827.137.335-2.016.827zM139.583 516.678l2.016-.827.137.336-2.016.827zM135.593 518.707l-4.127 1.693-.138-.336 4.127-1.693zm-8.254 3.386l-4.127 1.694-.138-.336 4.127-1.693zm-8.254 3.387l-4.127 1.693-.138-.336 4.127-1.693zM108.678 529.357l2.015-.827.138.335-2.016.827zM149.93 541.902l2.016-.827.137.335-2.016.828zM145.94 543.93l-4.126 1.694-.138-.336 4.127-1.693zm-8.253 3.387l-4.127 1.693-.138-.336 4.127-1.693zm-8.254 3.386l-4.127 1.693-.138-.336 4.127-1.693zM119.026 554.58l2.016-.827.137.336-2.015.827z"
  }), React.createElement("path", {
    d: "M130.632 550.512l116.175-47.66a11.48 11.48 0 006.258-14.963l-23.473-57.216-.227.1-28.51 68.168-21.144-8.84a2.742 2.742 0 00-2.435.152 2.922 2.922 0 00-1.212 1.433l-14.942 35.721-15.46-6.462a2.753 2.753 0 00-3.602 1.478c-.1.243-9.632 23.63-11.428 28.089z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M130.275 551.05l-.335-.14 11.954-28.586a3.09 3.09 0 014.038-1.656l15.155 6.337 14.856-35.525a3.09 3.09 0 014.038-1.656l20.84 8.714 28.655-68.523.335.14-28.796 68.859-21.174-8.855a2.723 2.723 0 00-3.563 1.461l-14.996 35.86-15.49-6.477a2.726 2.726 0 00-3.563 1.461z",
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 141.667,
    cy: 516.019,
    r: 2.542,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 174.906,
    cy: 485.115,
    r: 2.542,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 226.662,
    cy: 426.636,
    r: 2.542,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M84.401 513.135a10.095 10.095 0 003.61-15.052l7.549-73.804H79.246l-5.999 72.066a10.15 10.15 0 0011.154 16.79z",
    fill: "#ffb8b8"
  }), React.createElement("circle", {
    cx: 99.38,
    cy: 360.468,
    r: 23.08,
    fill: "#ffb8b8"
  }), React.createElement("path", {
    d: "M103.725 467.26a4.221 4.221 0 01-4.068-3.1c-1.85-6.718-6.66-18.077-14.3-33.763a27.967 27.967 0 0115.883-38.613 27.955 27.955 0 0135.921 17.808c5.921 18.563 5.635 38.447 5.238 46.134a4.239 4.239 0 01-3.321 3.913l-34.446 7.523a4.208 4.208 0 01-.907.098z",
    fill: "#ff6584"
  }), React.createElement("path", {
    fill: "#ffb8b8",
    d: "M137.082 686.425h11.52l5.481-44.437-17.003.001.002 44.436z"
  }), React.createElement("path", {
    d: "M170.82 697.122l-36.206.001-.001-13.99h22.218a13.99 13.99 0 0113.99 13.989z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    fill: "#ffb8b8",
    d: "M21.882 671.495l10.096 5.55 26.212-36.298-14.899-8.192-21.409 38.94z"
  }), React.createElement("path", {
    d: "M46.294 697.123L14.565 679.68l6.74-12.26 19.47 10.705a13.99 13.99 0 015.519 18.998zM136.544 661.76a4.228 4.228 0 01-4.19-3.684l-14.408-111.024a2.35 2.35 0 00-4.387-.832L53.514 655.16a4.252 4.252 0 01-5.209 1.911l-13.088-4.986a4.228 4.228 0 01-2.411-5.546L74.4 544.36a3.257 3.257 0 00.212-.81c5.634-43.605 19.969-65.78 24.228-71.537a3.275 3.275 0 00.466-2.982l-.586-1.756a4.226 4.226 0 01.814-4.113c15.346-17.48 42.095-7.942 42.363-7.844l.134.05.084.114c29.993 41.134 18.904 174.733 16.376 201.097a4.217 4.217 0 01-3.884 3.805l-17.736 1.366a4.42 4.42 0 01-.328.012z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M189.106 387.278a9.892 9.892 0 00-.225 1.54l-40.367 23.288-9.812-5.648-10.46 13.694 16.398 11.687a7.518 7.518 0 009.02-.22l41.625-32.838a9.864 9.864 0 10-6.179-11.503z",
    fill: "#ffb8b8"
  }), React.createElement("path", {
    d: "M147.165 413.21l-13.047 16.908a4.229 4.229 0 01-6.394.35l-14.77-15.336a11.744 11.744 0 0114.403-18.554l18.525 10.358a4.229 4.229 0 011.283 6.273zM96.598 442.587l-21.017-3.795a4.229 4.229 0 01-3.255-5.515l6.813-20.173a11.744 11.744 0 0123.102 4.242l-.665 21.213a4.229 4.229 0 01-4.978 4.028z",
    fill: "#ff6584"
  }), React.createElement("path", {
    d: "M103.033 355.159c5.932 4.06 13.72 8.233 19.78 3.91a11.025 11.025 0 003.618-12.71c-2.901-8.296-10.872-11.948-18.494-14.748-9.909-3.64-20.698-6.535-30.927-3.928s-19.269 12.51-17.422 22.903c1.485 8.358 9.368 15.312 8.25 23.727-1.127 8.469-10.651 12.927-19.06 14.44s-17.816 2-23.86 8.04c-7.708 7.704-5.783 21.475 1.47 29.609s18.2 11.822 28.806 14.328c14.053 3.321 29.252 5.067 42.599-.445s23.733-20.349 19.866-34.261c-1.633-5.877-5.48-10.844-9.198-15.679s-7.483-9.891-8.901-15.823c-1.182-4.944-.307-10.684 2.971-14.392a4.17 4.17 0 00.559-4.873z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M191 697.681H1a1 1 0 010-2h190a1 1 0 010 2z",
    fill: "#ccc"
  }));
}
exports.default = UndrawData;